import "./index.css";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { ws } from "./lib/ws";

// pages
import ErrorDisplay from "./components/error-display";
import Home from "./pages/home";
import { App } from "./components/app";
import { useEffect } from "react";

if (import.meta.env.VITE_SENTRY_DSN) {
  // https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Adds request headers and IP for users
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    tracesSampleRate: 0.01,
  });
}

ws.initialize();

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorDisplay type="UNEXPECTED" />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorDisplay type="PAGE_NOT_FOUND" />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />,
);
